import GreenPlus from '@assets/svg/common/green-plus.svg';
import RedCross from '@assets/svg/common/red-cross.svg';

export const ToastSuccessIcon = <img src={GreenPlus} alt="" />;
export const ToastErrorIcon = <img src={RedCross} alt="" />;
